<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';

  const responsiveVars = new ResponsiveVars()
    .addFluid('logo-height', toFluidVarInput(24, 36))
    .toCSS();
</script>

<div class={cx('logo-lockup-wrapper', responsiveVars)}>
  <img
    class="logo-lockup"
    src="/images/careers/block-ecosystem-lockup_black.svg"
    alt="Block ecosystem logo lockup showing the logos of Block, Square, Cash App, Afterpay, TIDAL, Bitkey, and Proto."
  />
</div>

<style>
  .logo-lockup-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo-lockup {
    height: var(--logo-height);
  }
</style>
